import React, { useContext } from 'react'
import { Box, Stack, Typography } from '@mui/material'
import { TenantSettingsContext } from '../../../App'

// Slim brand bar — the referee is a member of the public, so no navigation.
export default function Header() {
  const { orgSettings } = useContext(TenantSettingsContext).orgConfig

  return (
    <Box
      component="header"
      sx={{
        bgcolor: 'background.paper',
        borderBottom: 1,
        borderColor: 'divider',
        px: 2,
        py: 1.25,
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        gap={1.5}
        sx={{ maxWidth: 820, mx: 'auto' }}
      >
        {orgSettings?.logo && (
          <Box
            component="img"
            src={orgSettings.logo}
            alt=""
            sx={{ height: 40, maxWidth: 120, objectFit: 'contain' }}
          />
        )}
        <Typography fontWeight={600} noWrap>
          {orgSettings?.orgName}
        </Typography>
      </Stack>
    </Box>
  )
}
